module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', [_c('basic-toolbar', {
    attrs: {
      "title": 'Ocorrências do integrante ' + this.integrante.nome
    }
  }), _vm._v(" "), _c('v-card-title', [_c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "append-icon": "filter_list",
      "label": "Filtrar resultados"
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.listaOcorrenciasIntegrante,
      "search": _vm.search,
      "no-data-text": 'Esse integrante não possui ocorrências',
      "must-sort": "",
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "items-per-page": _vm.itemsPerPage,
      "footer-props": {
        itemsPerPageText: 'Linhas por página',
        itemsPerPageOptions: _vm.opcoesPaginacao
      }
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n            Mostrando " + _vm._s(pageStart) + " a " + _vm._s(pageStop) + " de " + _vm._s(_vm.listaOcorrenciasIntegrante.length) + " ocorrências\n          ")]
      }
    }, {
      key: "item.dtOcorrencia",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dtOcorrencia)))]
      }
    }, {
      key: "item.dataInicial",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dataInicial)))]
      }
    }, {
      key: "item.dataFinal",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dataFinal)))]
      }
    }, {
      key: "item.assessor",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.formatAssessor.format(props.item.assessor, props.item.funcao.item)))]
      }
    }])
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("Voltar")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fa796138","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/integrantes/ocorrencias-integrante.vue
// module id = 589
// module chunks = 0